__turbopack_context__.v({
  "authorAvatar": "GuideCard-module-scss-module__eVmqAW__authorAvatar",
  "authorImage": "GuideCard-module-scss-module__eVmqAW__authorImage",
  "authorName": "GuideCard-module-scss-module__eVmqAW__authorName",
  "backgroundImage": "GuideCard-module-scss-module__eVmqAW__backgroundImage",
  "cardContent": "GuideCard-module-scss-module__eVmqAW__cardContent",
  "numEvents": "GuideCard-module-scss-module__eVmqAW__numEvents",
  "root": "GuideCard-module-scss-module__eVmqAW__root",
});
